/** @jsx jsx */
import { jsx } from "@emotion/react";
import { ebookStyles, pathStyles, desktop, pathStylesMobile } from "../assets/styles/headerContent.styles";
import { Row, Container, Col } from 'react-bootstrap'
import EbookImage from '../assets/images/LP-versar/ebook.png'
import EbookMobile from '../assets/images/LP-versar/ebook-mobile.png'
import arrow from '../assets/images/LP-versar/bt-arrow.svg'
import path from '../assets/images/LP-versar/path.svg'
import pathMobile from '../assets/images/LP-versar/path-mobile.svg'

const HeaderContent = () => {
  return (
    <section css={ebookStyles}>
      <Container>
        <Row>
          <Col className="mobile" lg={8} md={12} sm={12}>
            <img src={EbookMobile} style={{ marginTop: 32, zIndex: 9, display: 'inline-block'}} />
            <img css={pathStylesMobile} src={pathMobile} style={{ marginTop: 24}} />
          </Col>
          <Col className='col-text' lg={4} md={12} sm={12}>
            <div className='text-container'>
              <h1><span>O Instagram</span> como aliado da sua escola</h1>
              <p>Estratégias de marketing educacional para ampliar resultados e atrair matrículas</p>
              <a href="#contato" className="button">
                <span>BAIXE O E-BOOK!</span>
                <img src={arrow} />
              </a>
            </div>
          </Col>
          <Col className="desktop" lg={8} md={12} sm={12}>
            <img css={desktop} src={EbookImage} />
            {/* <img css={mobile} src={EbookMobile} /> */}
          </Col>
        </Row>
      </Container>
      <img css={pathStyles} src={path} />
      
    </section>
  )
}

export default HeaderContent;
